import React from 'react';
import { RadioCardVariants } from './types';

const RadioCardContext = React.createContext<{
    variant?: RadioCardVariants;
    inputId?: string;
    expandableRegionId?: string;
    expanded?: boolean;
    'data-testid'?: string;
}>({});

export const RadioCardProvider = RadioCardContext.Provider;

export const useRadioCardProps = () => React.useContext(RadioCardContext);
